import listService from "@/services/list.service.js"

export const ListDetails = {
	namespaced : true,
	state :{
		list: []
	},
	actions:{
		async getList({commit}){
			// console.log("LIST ", listService)
			listService.getListFor(1).then(res=>{
				commit("setList",res)
			}).catch(erro=>{
				console.warn("Erro get list ListDetails ", error)
			});
		}
	},
	mutations:{
		setList(state, list) {
      		state.list = list;
	    },
	},
	getters:{
		getListDetails : (state)=> {
	        return state.list;
	      },
	},
}